module.exports = __webpack_public_path__ + "media/svg/bell-outline-5ed6e0f1.svg";